/**
 * Acquisitions Kanban Configuration
 *
 * Configuration for the Acquisitions kanban board using the global Kanban component.
 */

import { KanbanConfig } from "../types";
import { Acquisition, AcquisitionPhase } from "shared/types/acquisition";
import { acquisitionPhaseColumns } from "screens/acquisitions/acquisitionPhaseConfig";

/**
 * Acquisitions Kanban Configuration
 *
 * This config defines how the Acquisitions kanban should look and behave:
 * - Uses phase columns from acquisitionPhaseConfig (single source of truth)
 * - Shows count per column
 * - Shows plus button per column to add acquisitions
 * - Scrollable columns with fixed headers
 */
export const acquisitionsKanbanConfig: KanbanConfig<
  Acquisition,
  AcquisitionPhase
> = {
  // Column definitions from existing acquisitionPhaseConfig
  columns: acquisitionPhaseColumns,

  // Get the phase for an acquisition
  getItemStatus: (acquisition: Acquisition) => acquisition.acquisitionPhase!,

  // Show count badge per column
  showCount: true,

  // Show plus button per column to add acquisitions
  showAddButton: true,

  // Empty state configuration
  emptyState: {
    message: "Geen acquisities",
  },

  // Columns are scrollable with fixed headers (like Helpdesk)
  scrollableColumns: false,
};
